require('./resizeConfig');
require('./resizeService');

/**
 * @ngdoc directive
 * @name app.shared.resize.resizeDirective:resize
 * @description
 * # Emits and event on the scope when the window is resized
 */
angular.module('app.shared.resize.resizeDirective', [
  'app.shared.resize.resizeService',
  'app.shared.resize.RESIZE_CONFIG'
])
  .directive('resize', [
    '$window',
    'app.shared.resize.resizeService',
    'RESIZE_CONFIG',
    function ($window, sizeService, RESIZE_CONFIG) {
      "use strict";

      return {
        restrict: 'A',
        link: function (scope, element) {
          let resizeHandler = _.debounce(function () {
            scope.$broadcast(RESIZE_CONFIG.EVENT_NAME, sizeService.getSize(element));
          }, RESIZE_CONFIG.DEBOUNCE_MILLIS);

          angular
            .element($window)
            .bind('resize', resizeHandler);

          // Cleanup  event listener when directive is destroyed
          scope.$on('$destroy', function () {
            angular
              .element($window)
              .unbind('resize', resizeHandler);
          });
        }
      };
    }]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/resize/resizeDirective.js